import { useState } from "react";
import { useNavigate } from "react-router";

const CreatePost = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [kind, setKind] = useState("poem");
  const [theme, setTheme] = useState("gloom");
  const [explanation, setExplanation] = useState("");
  const [body, setBody] = useState("");
  const [isPending, setIsPending] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const post = {title, kind, theme, explanation, body};
    const response = await fetch('https://siteadeyemiwrites.herokuapp.com/api/posts', {
      method: 'POST',
      body: JSON.stringify(post),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    setIsPending(true);
    const json = await response.json();
    if (!response.ok) {
      setError(json.error);
      console.log('New Workout Added')
    }
    navigate('/poems');
  }
    return ( 
        <>
      <h1>Create Post</h1>
      <div className="create">
        <div className="create-form">
          {/* The Main Form */}
          <form onSubmit={handleSubmit}>
            {/* Title */}
            <label htmlFor="title">Title: </label>
            <input
              type="text"
              id="title"
              onChange={(e) => setTitle(e.target.value)}
              minLength="3"
              maxLength="50"
              required
            />

            {/* Post Type */}
            <label htmlFor="type">Type: </label>
            <select id="type" defaultValue={"poem"} onChange={(e)=> setKind(e.target.value)}>
              <option value="blog">Blog Post</option>
              <option value="poem">Poem</option>
              <option value="story">Story</option>
            </select>

            {/* Post Theme */}
            <label htmlFor="theme" defaultValue={"gloom"}>Theme: </label>
            <select id="theme" onChange={(e)=> setTheme(e.target.value)}>
              <option value="gloom">Gloom: </option>
              <option value="love">Love: </option>
              <option value="politics">Politics: </option>
              <option value="other">Other: </option>
            </select>

            {/* Post Body */}
            <label htmlFor="body">Body: </label>
            <textarea id="body" onChange={(e)=> setBody(e.target.value)}></textarea>

            {/* Post Explanation, mainly for poems */}
            <label htmlFor="exp">Meaning: </label>
            <textarea id="exp" onChange={(e) => setExplanation(e.target.value)}></textarea>
 

            {isPending && (<input type="submit" disabled value={"Adding blog..."} />)}
            {!isPending && <input type="submit" value="Submit" />}
            {error && <p> Couldn't perform that request </p>}
          </form>
        </div>
      </div>
    </>
     );
}
 
export default CreatePost;
